module.exports = __webpack_public_path__ + "static/media/BDO_2026_PDF.01879444.pdf";